import css from "assets/stylus/config/colors";

export default {
	red: css.colorRed,
	blue: css.colorBlue,
	green: css.colorGreen,
	yellow: css.colorYellow,
	purple: css.colorPurple,
	darkBlue: css.colorDarkBlue,
	brightBlue: css.colorBrightBlue,
};
